import React, { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Controller, useForm } from "react-hook-form";
import { InwardAccepted, InwardEdit } from "../../utils/apis/Inward/Inward";
import { Context } from "../../utils/context";
import Select from "react-select";
import {
  getBankDetail,
  kycStatus,
} from "../../utils/apis/Investores/Investores";
import Col from "react-bootstrap/Col";

import Row from "react-bootstrap/Row";
import { formatDate } from "../../utils/common";
import { error } from "jquery";
import BankDetails from "./BankDetails";

const BankDetailsModal = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    setError,
    setValue,
    control,
    reset,
  } = useForm();

  const options = [
    { value: "Accepted", label: "Accepted" },
    { value: "Rejected", label: "Rejected" },
  ];

  const [reasonShow, setReasonShow] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const { IMG_URL } = useContext(Context);

  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day} ${month} ${year}, ${hours}:${minutes}:${seconds}`;
  }

  const [viewBank, setViewBank] = useState(false);
  const [data, setData] = useState(false);
  const [dataHistory, setDataHistory] = useState("");
  const getData = async (id) => {
    const res = await getBankDetail(id);

    if (res.success) {
      setDataHistory(res?.data);
    } else {
    }
  };
  useEffect(() => {
    getData(props.kycID?.id);
  }, [props.kycID]);
  return (
    <>
      <Modal
        {...props}
        size="xl"
        className="Payment_Screenshotmodal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Bank Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive">
            <table className="table table-hover align-middle text-center">
              <thead className="table-dark">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Date</th>
                  <th scope="col">Bank Name</th>
                  <th scope="col">Bank Account No.</th>
                  <th scope="col">Bank Account Name</th>
                  <th scope="col">IFSC Code</th>
                  <th scope="col">Bank Status</th>
                  <th scope="col">Bank Verify</th>
                </tr>
              </thead>
              <tbody>
                {dataHistory?.bank_accounts?.length > 0 ? (
                  dataHistory.bank_accounts.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{formatDate(item.createdAt)}</td>
                      <td>{item.bank_name || "NA"}</td>
                      <td>{item.ac_no}</td>
                      <td>{item.holder_name}</td>
                      <td>{item.ifsc_code}</td>
                      <td>
                        <span
                          className={
                            item?.bank_status === "Accepted"
                              ? "text-success fw-bold"
                              : item?.bank_status === "Rejected"
                                ? "text-danger fw-bold"
                                : "text-warning fw-bold"
                          }
                        >
                          {item?.bank_status || "Unverified"}
                        </span>
                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-success"
                          style={{ height: "45px" }}
                          onClick={() => {
                            setViewBank(true);
                            setData(item);
                          }}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center py-4">
                      <span className="text-muted fw-bold">
                        No bank details uploaded
                      </span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <BankDetails
          show={viewBank}
          onHide={() => setViewBank(false)}
          bankdata={data}
          kycID={props?.kycID}
          getData={getData}
          // detailType={detailType}
        />
      </Modal>
    </>
  );
};

export default BankDetailsModal;
